import { render, staticRenderFns } from "./TypeVenteNew.vue?vue&type=template&id=3c132bc4&"
import script from "./TypeVenteNew.vue?vue&type=script&lang=js&"
export * from "./TypeVenteNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c132bc4')) {
      api.createRecord('3c132bc4', component.options)
    } else {
      api.reload('3c132bc4', component.options)
    }
    module.hot.accept("./TypeVenteNew.vue?vue&type=template&id=3c132bc4&", function () {
      api.rerender('3c132bc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/type_vente/TypeVenteNew.vue"
export default component.exports